import React from 'react'
import classNames from 'classnames'
import { Button, Field, Input, Label, Select, RadioGroup, SimpleRadio } from '../../atoms'
import { getPrefix, getText } from './currencies'

export const Filters = ({ filters, direction, isAlwaysVisible, defaultInputs = {} }) => {
  return (
    <div
      className={classNames('ProductTable__filterBlock', {
        'ProductTable__filterBlock--visible': isAlwaysVisible,
      })}
      data-filter-block
    >
      <div
        className={classNames('ProductTable__filterBlock__fields', {
          'ProductTable__filterBlock__fields--column': direction === 'column',
        })}
      >
        {filters.map((filter, key) => {
          if (filter.type === 'dropdown') {
            const sortOptions = filter.options.map((o) => {
              return { text: o.label, value: o.value ?? o.label }
            })
            return (
              <Field key={key} stack={filter.stack}>
                <Label>{filter.label}</Label>
                <Select
                  name={filter.label}
                  value={defaultInputs[filter.name] ?? sortOptions[0].value}
                  options={sortOptions}
                  onChange={() => {}}
                  brand={'uswitch'}
                />
              </Field>
            )
          } else if (filter.type === 'checkbox') {
            return (
              <Field key={key} stack={filter.stack} className='filterBlock--checkbox'>
                <Label>{filter.label}</Label>
                <div className='ProductTable__filterBlock__fields--checkboxWrapper'>
                  {filter.options.map((option, optionKey) => {
                    return (
                      <div className='ProductTable__filterBlock__fields--checkbox' key={optionKey}>
                        <label>
                          <input type='checkbox' />
                          <span />
                          {option.label}
                        </label>
                      </div>
                    )
                  })}
                </div>
              </Field>
            )
          } else if (filter.type === 'input') {
            return (
              <Field key={key} stack={filter.stack}>
                <Label>{filter.label}</Label>
                <Input
                  type='number'
                  value={defaultInputs[filter.name]}
                  name={filter.name}
                  prefix={filter.prefix}
                />
              </Field>
            )
          } else if (filter.type === 'radio') {
            return (
              <Field key={key} stack={filter.stack}>
                <Label>{filter.label}</Label>
                <RadioGroup>
                  {filter.options.map((option, index) => {
                    return (
                      <SimpleRadio
                        name={filter.name}
                        id={option.value}
                        key={index}
                        value={option.value}
                        checked={defaultInputs[filter.name] === option.value}
                      >
                        {option.label}
                      </SimpleRadio>
                    )
                  })}
                </RadioGroup>
              </Field>
            )
          } else if (filter.type === 'travelMoneyCurrency') {
            return (
              <div
                key={key}
                data-travel-money-currency={JSON.stringify([
                  { currency: filter.currency, prefix: getPrefix(filter.currency) },
                ])}
              >
                <Field stack={true}>
                  <Label>Amount to convert</Label>
                  <Input
                    type='number'
                    value={defaultInputs.gbpAmount ?? defaultInputs.otherAmount}
                    name={defaultInputs.currencyToUse === 'GBP' ? 'gbpAmount' : 'otherAmount'}
                    prefix={
                      defaultInputs.currencyToUse === 'GBP'
                        ? '£'
                        : getPrefix(defaultInputs.currencyPair)
                    }
                  />
                </Field>

                <Field stack={true}>
                  <Label>Source currency</Label>
                  <RadioGroup>
                    <SimpleRadio
                      name='currencyToUse'
                      id='GBP'
                      value='GBP'
                      checked={defaultInputs.currencyToUse === 'GBP'}
                    >
                      GBP
                    </SimpleRadio>
                    <SimpleRadio
                      name='currencyToUse'
                      id={filter.currency}
                      value={filter.currency}
                      checked={defaultInputs.currencyToUse !== 'GBP'}
                    >
                      {filter.currency}
                    </SimpleRadio>
                  </RadioGroup>
                </Field>
              </div>
            )
          } else if (filter.type === 'travelMoneyCurrencies') {
            const currencyOptions = filter.currencies.map((c) => ({
              value: c,
              text: `${getText(c)} (${c})`,
            }))
            return (
              <div
                className='ProductTable__filterBlock__travelMoneyCurrencies'
                key={key}
                data-travel-money-currencies={JSON.stringify(
                  filter.currencies.map((c) => ({
                    currency: c,
                    prefix: getPrefix(c),
                  })),
                )}
              >
                <Field stack={true}>
                  <Label>Amount to convert</Label>
                  <Input
                    type='number'
                    value={defaultInputs.gbpAmount ?? defaultInputs.otherAmount}
                    name={defaultInputs.currencyToUse === 'GBP' ? 'gbpAmount' : 'otherAmount'}
                    prefix={
                      defaultInputs.currencyToUse === 'GBP'
                        ? '£'
                        : getPrefix(defaultInputs.currencyPair)
                    }
                  />
                </Field>

                <Field
                  stack={true}
                  className={classNames({
                    'ProductTable__filterBlock__travelMoneyCurrencies-2':
                      defaultInputs.currencyToUse === 'GBP',
                    'ProductTable__filterBlock__travelMoneyCurrencies-4':
                      defaultInputs.currencyToUse !== 'GBP',
                  })}
                >
                  <Label>From</Label>
                  <div className='ProductTable__filterBlock__static-select'>
                    <div>British Pound (GBP)</div>
                  </div>
                </Field>
                <div className='ProductTable__filterBlock__swap'>
                  <input
                    type='image'
                    id='swap'
                    alt='Switch'
                    src='/fs-core-assets/icons/money/swap-circle-plum.svg'
                  />
                </div>
                <Field
                  stack={true}
                  className={classNames({
                    'ProductTable__filterBlock__travelMoneyCurrencies-2':
                      defaultInputs.currencyToUse !== 'GBP',
                    'ProductTable__filterBlock__travelMoneyCurrencies-4':
                      defaultInputs.currencyToUse === 'GBP',
                  })}
                >
                  <Label>To</Label>
                  <Select
                    name='currencyPair'
                    value={defaultInputs.currencyPair}
                    options={currencyOptions}
                    onChange={() => {}}
                    brand={'money'}
                  />
                </Field>
              </div>
            )
          } else {
            return <></>
          }
        })}
      </div>
      <Button>Update results</Button>

      <div className='ProductTable__filterBlock__noResults'>
        There are no results matching your search, please try again
      </div>
    </div>
  )
}
